import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles(theme => ({
  roleText:{

    display: "flex",
    backgroundColor: theme.tooltip.styleTwo.backgroundColor,
    borderRadius: "16px",
    padding: "2px 8px",
    gap: "5px",
    "& p": {
      margin: "0px",
      fontSize: "12px",
      color: theme.tooltip.styleTwo.color,
      fontWeight:"500",
      lineHeight:"18px",
      textAlign:"left",
      display: "flex",
      alignItems: "center"
    },
    "&:hover": {
      backgroundColor: theme.tooltip.styleTwo.hover.backgroundColor,

      "& path": {
        stroke: theme.tooltip.styleTwo.hover.pathBackgroundColor
      }
    },
  },
  infoIcon:{
    marginTop: "auto",
    marginBottom: "auto",
    cursor: "pointer",
    "& path": {
      stroke: theme.tooltip.styleTwo.pathBackgroundColor
    }
  },
  infoPopoverDiv:{
    display:"flex",
    flexDirection:"column",
    alignItems:"start",
    backgroundColor:  colors.white,
    padding: "12px",
    borderRadius: 8,
    color:  colors.grey,
    width:"328px !important"
  },
  infoPopover:{
    "& .popover-arrow::before": {
      border:"none",
    },
    bottom: "14px !important",
    maxWidth: "fit-content",
    border:"none",
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
  },
  infoTitle:{
    fontSize: "12px",
    color: colors.grey,
    fontWeight:"600",
    lineHeight:"18px",
    marginBottom: "4px"
  },
  infoDescription:{
    fontSize: "12px",
    color: colors.inactiveGrey,
    fontWeight:"500",
    lineHeight:"18px",
  },
}));

export default styles;
